import React, { useState } from "react";
import { Container, CssBaseline, Button, TextField } from "@mui/material";
import { Link, Link as RouterLink } from "react-router-dom"; // Import Link from react-router-dom
import logoImage from "../../data/springview-logo.png";
import "./login.css";
import axiosClient from "../../axios-client";
import { useStateContext } from "../../contexts/ContextProvider";

function Login() {
  const { user, token, setUser, setToken } = useStateContext();
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFormSubmit = (e) => {
    setIsLoggingIn(true);
    e.preventDefault();

    // Basic input validation
    let validationPassed = true;
    const updatedErrors = { ...errors };

    if (!formData.email) {
      updatedErrors.email = "Email is required";
      validationPassed = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      updatedErrors.email = "Invalid email format";
      validationPassed = false;
    } else {
      updatedErrors.email = "";
    }

    if (!formData.password) {
      updatedErrors.password = "Password is required";
      validationPassed = false;
    } else {
      updatedErrors.password = "";
    }

    setErrors(updatedErrors);

    if (validationPassed) {
      // Handle form submission here
      axiosClient
        .post("login", formData)
        .then(({ data }) => {
          setUser(data.user);
          setToken(data.token);
          // axiosClient.get("/modules").then(({ data }) => {
          //     setModules(data.modules);
          //     setRole(data.role);
          //   });
        })
        .catch((err) => {
          setIsLoggingIn(false)
          const response = err.response;
          if (response && response.status === 422) {
            if (response.data.errors) {
              setErrors(response.data.errors);
            } else {
              setErrors({
                email: [response.data.message],
              });
            }
          }
        });
    } else {
      setIsLoggingIn(false)
    }
  };

  return (
    <div className="animated fadeInDown">
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className="min-h-screen flex flex-col items-center justify-center">
          <div className="bg-white dark:bg-gray-800 p-8 rounded shadow-lg w-full max-w-md">
            <img
              src={logoImage} // Replace with your logo path
              alt="Springview Cleaning"
              className="max-w-xxs -mt-20 mb-8 mx-auto"
            />

            <h1 className="text-4xl text-center text-emerald-900 font-medium mb-4">
              Welcome back!
            </h1>
            <h1 className="text-sm text-emerald-700 text-center mb-1">
              Login to your account
            </h1>
            <form onSubmit={handleFormSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                error={!!errors.email}
                helperText={errors.email}
              />
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Password"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                error={!!errors.password}
                helperText={errors.password}
              />
              <div className="pt-8">
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="success"
                  //   style={{ backgroundColor: "#058434", color: "#FFFFFF" }}
                  disabled={isLoggingIn}
                >
                  Log in
                </Button>
                <p className="mt-2 text-green-700 text-right cursor-pointer hover:text-red-700">
                  {/* Use react-router-dom's Link component to redirect */}
                  {!isLoggingIn ? (
                    <Link to="/forgot-password">Forgot password? </Link>
                  ) : (
                    <span>Forgot password?</span>
                  )}
                </p>
              </div>
            </form>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Login;
